// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".a-ViewAlarmy .rowBold .x-grid-cell {\r\n    font-weight: bold\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/views/ViewAlarmy/ViewAlarmy.css"],"names":[],"mappings":"AAAA;IACI;AACJ","sourcesContent":[".a-ViewAlarmy .rowBold .x-grid-cell {\r\n    font-weight: bold\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
